import React from "react";
import { Col, Row } from "react-bootstrap";
import { getScaleColors } from "../../../../../../../Helpers/RgbColorHelper";

export default function Detail_1({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Get color variations using helper
  const colors = getScaleColors(item.scale);

  return (
    //item.name = Hayal Gücü, item.scopeName = Açıklık
    <Row style={{ height: Number(item.height) }}>
      <div>
        <Row className={"_detail-section-sub-scope-name-header-pdf"}>{isSub && item.scopeName}</Row>
        <Row
          xs={isSub ? "auto" : 12}
          className={
            "mb-2 " +
            (isSub ? "_detail-section-sub-scope-name-header-pdf-new" : "_detail-section-scope-name-header-pdf-new")
          }
        >
          <Col className={"align-content-center text-end  ps-0"}>{item.name}</Col>
          <Col className={"ps-0"}>
            <div
              className={
                (!isSub ? "_main-scope-score-header-pdf-detail-new" : "_sub-scope-score-pdf") + " _flex-center"
              }
              style={{
                backgroundColor: colors.primary,
                color: "#ffffff",
                border: `2px solid ${colors.dark}`,
              }}
            >
              {elementScore}
            </div>
          </Col>
        </Row>

        <Row className="_scope-detail-scope-container-new">
          {item.scale.ranges.map((range, i) => {
            const isHit = range.isHit;
            return (
              <Col
                key={i}
                className="_scale-style-pdf-new _flex-center"
                style={
                  isHit
                    ? {
                        backgroundColor: colors.light,
                        borderColor: colors.primary,
                        border: `2px solid ${colors.primary}`,
                        color: colors.dark,
                        fontWeight: "bold",
                      }
                    : {}
                }
              >
                {item.scale.isHtml ? <div dangerouslySetInnerHTML={{ __html: range.text }} /> : range.text}
              </Col>
            );
          })}
        </Row>
        <Row>
          <Col xs="5" className={"px-1"}>
            <div className="_scale-detail-text-pdf-new" dangerouslySetInnerHTML={{ __html: item.lowSideText }} />
          </Col>
          <Col xs={{ offset: 2, span: 5 }} className={"px-1"}>
            <div className="_scale-detail-text-pdf-new" dangerouslySetInnerHTML={{ __html: item.highSideText }} />
          </Col>
        </Row>
        {item.generalInformationText?.length > 2 && (
          <div
            className="_scale-detail-text-new mb-2"
            dangerouslySetInnerHTML={{ __html: item.generalInformationText }}
          />
        )}
      </div>
    </Row>
  );
}
